import i18nFilter from "@/filters/i18n.filter";
import { auth } from "@/firebase";
import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";

const Home = () => import("../views/Home.vue");
const Course = () => import("../views/Course.vue");
const Schedule = () => import("../views/Schedule.vue");
const Messengers = () => import("../views/Messengers.vue");
const Help = () => import("../views/Help.vue");
const EmptyView = () => import("../views/EmptyView.vue");
const EventsAll = () => import("../views/admin/events/All.vue");
const EventsEdit = () => import("../views/admin/events/Edit.vue");
const CoursesAll = () => import("../views/admin/courses/All.vue");
const CoursesEdit = () => import("../views/admin/courses/Edit.vue");
const PaymentsAll = () => import("../views/admin/payments/All.vue");
const PaymentsEdit = () => import("../views/admin/payments/Edit.vue");
const PromocodesAll = () => import("../views/admin/promocodes/All.vue");
const PromocodesEdit = () => import("../views/admin/promocodes/Edit.vue");
const FormsAll = () => import("../views/admin/forms/All.vue");
const Login = () => import("../views/auth/Login.vue");
const Register = () => import("../views/auth/Register.vue");
const PasswordReset = () => import("../views/auth/PasswordReset.vue");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { layout: "main", title: i18nFilter("PageTitle_Home"), auth: true }
  },
  {
    path: "/courses/:id",
    name: "course-page",
    component: Course,
    meta: { layout: "main", title: i18nFilter("PageTitle_Course"), auth: true }
  },
  {
    path: "/schedule",
    name: "schedule",
    component: Schedule,
    meta: {
      layout: "main",
      title: i18nFilter("PageTitle_Schedule"),
      auth: true
    }
  },
  {
    path: "/messengers",
    name: "messengers",
    component: Messengers,
    meta: {
      layout: "main",
      title: i18nFilter("PageTitle_Messengers"),
      auth: true
    }
  },
  {
    path: "/help",
    name: "help",
    component: Help,
    meta: {
      layout: "main",
      title: i18nFilter("PageTitle_HelpCenter"),
      auth: true
    }
  },
  {
    path: "/admin",
    redirect: "/admin/events",
    component: EmptyView,
    meta: { layout: "main", auth: true, employee: true },
    children: [
      {
        path: "events",
        component: EmptyView,
        meta: { layout: "main", auth: true, employee: true },
        children: [
          {
            path: "",
            name: "events-page",
            component: EventsAll,
            meta: {
              layout: "main",
              title: i18nFilter("PageTitle_Events"),
              auth: true,
              employee: true
            }
          },
          {
            path: "edit",
            component: EmptyView,
            meta: { layout: "main", auth: true, employee: true },
            children: [
              {
                path: "",
                name: "add-event-page",
                component: EventsEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_AddEvent"),
                  auth: true,
                  employee: true
                }
              },
              {
                path: ":id",
                name: "edit-event-page",
                component: EventsEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_EditEvent"),
                  auth: true,
                  employee: true
                }
              }
            ]
          }
        ]
      },
      {
        path: "courses",
        component: EmptyView,
        meta: { layout: "main", auth: true, employee: true },
        children: [
          {
            path: "",
            name: "courses-page",
            component: CoursesAll,
            meta: {
              layout: "main",
              title: i18nFilter("PageTitle_Courses"),
              auth: true,
              employee: true
            }
          },
          {
            path: "edit",
            component: EmptyView,
            meta: { layout: "main", auth: true, employee: true },
            children: [
              {
                path: "",
                name: "add-course-page",
                component: CoursesEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_AddCourse"),
                  auth: true,
                  employee: true
                }
              },
              {
                path: ":id",
                name: "edit-course-page",
                component: CoursesEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_EditCourse"),
                  auth: true,
                  employee: true
                }
              }
            ]
          }
        ]
      },
      {
        path: "payments",
        component: EmptyView,
        meta: { layout: "main", auth: true, employee: true },
        children: [
          {
            path: "",
            name: "payments-page",
            component: PaymentsAll,
            meta: {
              layout: "main",
              title: i18nFilter("PageTitle_Payments"),
              auth: true,
              employee: true
            }
          },
          {
            path: "edit",
            component: EmptyView,
            meta: { layout: "main", auth: true, employee: true },
            children: [
              {
                path: "",
                name: "add-payment-page",
                component: PaymentsEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_AddPayment"),
                  auth: true,
                  employee: true
                }
              },
              {
                path: ":id",
                name: "edit-payment-page",
                component: PaymentsEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_EditPayment"),
                  auth: true,
                  employee: true
                }
              }
            ]
          }
        ]
      },
      {
        path: "promocodes",
        component: EmptyView,
        meta: { layout: "main", auth: true, employee: true },
        children: [
          {
            path: "",
            name: "promocodes-page",
            component: PromocodesAll,
            meta: {
              layout: "main",
              title: i18nFilter("PageTitle_Promocodes"),
              auth: true,
              employee: true
            }
          },
          {
            path: "edit",
            component: EmptyView,
            meta: { layout: "main", auth: true, employee: true },
            children: [
              {
                path: "",
                name: "add-promocode-page",
                component: PromocodesEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_AddPromocode"),
                  auth: true,
                  employee: true
                }
              },
              {
                path: ":id",
                name: "edit-promocode-page",
                component: PromocodesEdit,
                meta: {
                  layout: "main",
                  title: i18nFilter("PageTitle_EditPromocode"),
                  auth: true,
                  employee: true
                }
              }
            ]
          }
        ]
      },
      {
        path: "forms",
        component: EmptyView,
        meta: { layout: "main", auth: true, employee: true },
        children: [
          {
            path: "",
            name: "forms-page",
            component: FormsAll,
            meta: {
              layout: "main",
              title: i18nFilter("PageTitle_Forms"),
              auth: true,
              employee: true
            }
          }
        ]
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { layout: "auth" }
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { layout: "auth" }
  },
  {
    path: "/reset-password",
    name: "reset password",
    component: PasswordReset,
    meta: { layout: "auth" }
  },
  { path: "*", redirect: "/" }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

const showError = err => {
  store.commit("setError", err);
};

const isEmployee = email => {
  return /.*@facestudio\.online$/.test(email);
};

router.beforeEach((to, from, next) => {
  const privateRoute = to.matched.some(record => record.meta.auth);
  const employeeRoute = to.matched.some(record => record.meta.employee);
  const query = to.query;

  auth.onAuthStateChanged(currentUser => {
    if (privateRoute) {
      if (!currentUser) {
        next({
          path: "/register",
          query: { redirect: to.path, ...query }
        });
      } else {
        if (employeeRoute && !isEmployee(currentUser.email)) {
          next("/");
          showError("unauthorized");
        } else {
          const { redirect, ...rest } = query;
          if (redirect) next({ path: redirect, query: rest });
          else next();
        }
      }
    } else if (!privateRoute) {
      if (!currentUser) {
        next();
      } else {
        const { redirect, ...rest } = query;
        if (redirect) next({ path: redirect, query: rest });
        else next("/");
      }
    } else {
      next();
    }
  });
});

export default router;
